/**
 * Default "few minutes" window for catalog/CMS GETs before deterministic jitter.
 * Pair with {@link staleTimeWithJitterFromKey} and keys from {@link ./query-keys}.
 */
export const CATALOG_STALE_BASE_MS = 5 * 60 * 1000;

/**
 * Adds 0–30% of `baseMs` (exclusive upper bound on the extra amount) derived from
 * `queryKey` so each key gets a stable offset without `Math.random()` per render.
 */
export function staleTimeWithJitterFromKey(baseMs: number, queryKey: readonly unknown[]): number {
  const jitterCap = Math.max(1, Math.floor(baseMs * 0.3));
  let h = 2166136261;
  const s = JSON.stringify(queryKey);
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return baseMs + (Math.abs(h) % jitterCap);
}
